<template>
  <div class="main-content-container container-fluid h-100 px-4">
    <d-row no-gutters class="h-100">
      <d-col lg="3" md="5" class="auth-form mx-auto my-auto">
        <d-card>
          <d-card-body>
            <!-- Logo -->
            <img
              class="auth-form__logo d-table mx-auto mb-3"
              src="@/assets/images/spring-logo.svg"
              alt="Shards Dashboards - Forgot Password Template"
            />

            <!-- Title -->
            <h5 class="auth-form__title text-center mb-4">{{ $t("auth.forgottitle") }}</h5>

            <!-- Form Fields -->
            <d-form @submit="requestEmail" v-if="!emailSent">
              <div class="form-group mb-4">
                <label for="exampleInputEmail1">{{ $t("auth.email") }}</label>
                <d-input
                  type="email"
                  id="exampleInputEmail1"
                  placeholder="enter email"
                  v-model="email"
                />
                <d-form-text class="text-muted text-center pt-2">{{ $t("auth.forgotsub") }}</d-form-text>
              </div>
              <d-button
                type="submit"
                class="btn-accent login-btn d-table mx-auto"
                :disabled="isAuthLoading"
              >{{ isAuthLoading ? 'Sending email...' : 'Reset Password' }}</d-button>
            </d-form>
            <div v-else>
              <d-form-text
                class="text-muted text-center pt-2"
              >Email sent! Please check your mailbox.</d-form-text>
            </div>
          </d-card-body>
        </d-card>

        <!-- Meta -->
        <div class="auth-form__meta d-flex mt-4">
          <d-link tag="a" to="login" class="mx-auto cursor">
            <i class="material-icons">&#xE5C4;</i>
            {{ $t("auth.backtologin") }}
          </d-link>
        </div>
      </d-col>
    </d-row>
  </div>
</template>
<script>
import { AUTH_REQUEST_PASSWORD_CHANGE } from "@/store/types";
import { mapGetters } from "vuex";

export default {
  computed: { ...mapGetters(["isAuthLoading"]) },
  data() {
    return {
      email: "",
      emailSent: false
    };
  },
  methods: {
    async requestEmail(e) {
      e.preventDefault();

      const { email } = this;

      try {
        await this.$store.dispatch(AUTH_REQUEST_PASSWORD_CHANGE, email);
        this.emailSent = true;
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>


